var _defineProperty = require("C:\\Users\\TaeYongKong\\Documents\\GitHub\\deliquick-app-master-v2\\deliquick-app-master\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/defineProperty");

var _classCallCheck = require("C:\\Users\\TaeYongKong\\Documents\\GitHub\\deliquick-app-master-v2\\deliquick-app-master\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("C:\\Users\\TaeYongKong\\Documents\\GitHub\\deliquick-app-master-v2\\deliquick-app-master\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createClass");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var _require = require('./runtime_support'),
    keyObjectSupported = _require.keyObjectSupported;

var _createPublicKey;

var _createPrivateKey2;

var createSecretKey;
var KeyObject;
var asInput;

if (keyObjectSupported) {
  var _require2 = require('crypto');

  _createPublicKey = _require2.createPublicKey;
  _createPrivateKey2 = _require2.createPrivateKey;
  createSecretKey = _require2.createSecretKey;
  KeyObject = _require2.KeyObject;

  asInput = function asInput(input) {
    return input;
  };
} else {
  var _require3 = require('os'),
      EOL = _require3.EOL;

  var errors = require('../errors');

  var isObject = require('./is_object');

  var asn1 = require('./asn1');

  var toInput = Symbol('toInput');
  var namedCurve = Symbol('namedCurve');

  asInput = function asInput(keyObject, needsPublic) {
    if (keyObject instanceof KeyObject) {
      return keyObject[toInput](needsPublic);
    }

    return createSecretKey(keyObject)[toInput](needsPublic);
  };

  var pemToDer = function pemToDer(pem) {
    return Buffer.from(pem.replace(/(?:-----(?:BEGIN|END)(?: (?:RSA|EC))? (?:PRIVATE|PUBLIC) KEY-----|\s)/g, ''), 'base64');
  };

  var derToPem = function derToPem(der, label) {
    return "-----BEGIN ".concat(label, "-----").concat(EOL).concat((der.toString('base64').match(/.{1,64}/g) || []).join(EOL)).concat(EOL, "-----END ").concat(label, "-----");
  };

  var unsupported = function unsupported(input) {
    var label = typeof input === 'string' ? input : "OID ".concat(input.join('.'));
    throw new errors.JOSENotSupported("".concat(label, " is not supported in your Node.js runtime version"));
  };

  KeyObject =
  /*#__PURE__*/
  function () {
    "use strict";

    function KeyObject() {
      _classCallCheck(this, KeyObject);
    }

    _createClass(KeyObject, [{
      key: "export",
      value: function _export() {
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            cipher = _ref.cipher,
            passphrase = _ref.passphrase,
            type = _ref.type,
            format = _ref.format;

        if (this._type === 'secret') {
          return this._buffer;
        }

        if (this._type === 'public') {
          if (this.asymmetricKeyType === 'rsa') {
            switch (type) {
              case 'pkcs1':
                if (format === 'pem') {
                  return this._pem;
                }

                return pemToDer(this._pem);

              case 'spki':
                {
                  var PublicKeyInfo = asn1.get('PublicKeyInfo');
                  var pem = PublicKeyInfo.encode({
                    algorithm: {
                      algorithm: 'rsaEncryption',
                      parameters: {
                        type: 'null'
                      }
                    },
                    publicKey: {
                      unused: 0,
                      data: pemToDer(this._pem)
                    }
                  }, 'pem', {
                    label: 'PUBLIC KEY'
                  });
                  return format === 'pem' ? pem : pemToDer(pem);
                }

              default:
                throw new TypeError("The value ".concat(type, " is invalid for option \"type\""));
            }
          }

          if (this.asymmetricKeyType === 'ec') {
            if (type !== 'spki') {
              throw new TypeError("The value ".concat(type, " is invalid for option \"type\""));
            }

            if (format === 'pem') {
              return this._pem;
            }

            return pemToDer(this._pem);
          }
        }

        if (this._type === 'private') {
          if (passphrase !== undefined || cipher !== undefined) {
            throw new errors.JOSENotSupported('encrypted private keys are not supported in your Node.js runtime version');
          }

          if (type === 'pkcs8') {
            if (this._pkcs8) {
              if (format === 'der' && typeof this._pkcs8 === 'string') {
                return pemToDer(this._pkcs8);
              }

              if (format === 'pem' && Buffer.isBuffer(this._pkcs8)) {
                return derToPem(this._pkcs8, 'PRIVATE KEY');
              }

              return this._pkcs8;
            }

            if (this.asymmetricKeyType === 'rsa') {
              var parsed = this._asn1;
              var RSAPrivateKey = asn1.get('RSAPrivateKey');
              var privateKey = RSAPrivateKey.encode(parsed);
              var PrivateKeyInfo = asn1.get('PrivateKeyInfo');
              var pkcs8 = PrivateKeyInfo.encode({
                version: 0,
                privateKey: privateKey,
                algorithm: {
                  algorithm: 'rsaEncryption',
                  parameters: {
                    type: 'null'
                  }
                }
              });
              this._pkcs8 = pkcs8;
              return this.export({
                type: type,
                format: format
              });
            }

            if (this.asymmetricKeyType === 'ec') {
              var _parsed = this._asn1;
              var ECPrivateKey = asn1.get('ECPrivateKey');

              var _privateKey = ECPrivateKey.encode({
                version: _parsed.version,
                privateKey: _parsed.privateKey,
                publicKey: _parsed.publicKey
              });

              var _PrivateKeyInfo = asn1.get('PrivateKeyInfo');

              var _pkcs = _PrivateKeyInfo.encode({
                version: 0,
                privateKey: _privateKey,
                algorithm: {
                  algorithm: 'ecPublicKey',
                  parameters: this._asn1.parameters
                }
              });

              this._pkcs8 = _pkcs;
              return this.export({
                type: type,
                format: format
              });
            }
          }

          if (this.asymmetricKeyType === 'rsa' && type === 'pkcs1') {
            if (format === 'pem') {
              return this._pem;
            }

            return pemToDer(this._pem);
          } else if (this.asymmetricKeyType === 'ec' && type === 'sec1') {
            if (format === 'pem') {
              return this._pem;
            }

            return pemToDer(this._pem);
          } else {
            throw new TypeError("The value ".concat(type, " is invalid for option \"type\""));
          }
        }
      }
    }, {
      key: toInput,
      value: function value(needsPublic) {
        switch (this._type) {
          case 'secret':
            return this._buffer;

          case 'public':
            return this._pem;

          default:
            if (needsPublic) {
              if (!('_pub' in this)) {
                this._pub = _createPublicKey(this);
              }

              return this._pub[toInput](false);
            }

            return this._pem;
        }
      }
    }, {
      key: "type",
      get: function get() {
        return this._type;
      }
    }, {
      key: "asymmetricKeyType",
      get: function get() {
        return this._asymmetricKeyType;
      }
    }, {
      key: "symmetricKeySize",
      get: function get() {
        return this._symmetricKeySize;
      }
    }]);

    return KeyObject;
  }();

  createSecretKey = function createSecretKey(buffer) {
    if (!Buffer.isBuffer(buffer) || !buffer.length) {
      throw new TypeError('input must be a non-empty Buffer instance');
    }

    var keyObject = new KeyObject();
    keyObject._buffer = Buffer.from(buffer);
    keyObject._symmetricKeySize = buffer.length;
    keyObject._type = 'secret';
    return keyObject;
  };

  _createPublicKey = function createPublicKey(input) {
    if (input instanceof KeyObject) {
      if (input.type !== 'private') {
        throw new TypeError("Invalid key object type ".concat(input.type, ", expected private."));
      }

      switch (input.asymmetricKeyType) {
        case 'ec':
          {
            var PublicKeyInfo = asn1.get('PublicKeyInfo');

            var _key = PublicKeyInfo.encode({
              algorithm: {
                algorithm: 'ecPublicKey',
                parameters: input._asn1.parameters
              },
              publicKey: input._asn1.publicKey
            });

            return _createPublicKey({
              key: _key,
              format: 'der',
              type: 'spki'
            });
          }

        case 'rsa':
          {
            var RSAPublicKey = asn1.get('RSAPublicKey');

            var _key2 = RSAPublicKey.encode(input._asn1);

            return _createPublicKey({
              key: _key2,
              format: 'der',
              type: 'pkcs1'
            });
          }
      }
    }

    if (typeof input === 'string' || Buffer.isBuffer(input)) {
      input = {
        key: input,
        format: 'pem'
      };
    }

    if (!isObject(input)) {
      throw new TypeError('input must be a string, Buffer or an object');
    }

    var _input = input,
        format = _input.format,
        passphrase = _input.passphrase;
    var _input2 = input,
        key = _input2.key,
        type = _input2.type;

    if (typeof key !== 'string' && !Buffer.isBuffer(key)) {
      throw new TypeError('key must be a string or Buffer');
    }

    if (format !== 'pem' && format !== 'der') {
      throw new TypeError('format must be one of "pem" or "der"');
    }

    var label;

    if (format === 'pem') {
      key = key.toString();

      switch (key.split(/\r?\n/g)[0].toString()) {
        case '-----BEGIN PUBLIC KEY-----':
          type = 'spki';
          label = 'PUBLIC KEY';
          break;

        case '-----BEGIN RSA PUBLIC KEY-----':
          type = 'pkcs1';
          label = 'RSA PUBLIC KEY';
          break;

        case '-----BEGIN CERTIFICATE-----':
          throw new errors.JOSENotSupported('X.509 certificates are not supported in your Node.js runtime version');

        case '-----BEGIN PRIVATE KEY-----':
        case '-----BEGIN EC PRIVATE KEY-----':
        case '-----BEGIN RSA PRIVATE KEY-----':
          return _createPublicKey(_createPrivateKey2(key));

        default:
          throw new TypeError('unknown/unsupported PEM type');
      }
    }

    switch (type) {
      case 'spki':
        {
          var _PublicKeyInfo = asn1.get('PublicKeyInfo');

          var parsed = _PublicKeyInfo.decode(key, format, {
            label: label
          });

          var _type, keyObject;

          switch (parsed.algorithm.algorithm) {
            case 'ecPublicKey':
              {
                keyObject = new KeyObject();
                keyObject._asn1 = parsed;
                keyObject._asymmetricKeyType = 'ec';
                keyObject._type = 'public';
                keyObject._pem = _PublicKeyInfo.encode(parsed, 'pem', {
                  label: 'PUBLIC KEY'
                });
                break;
              }

            case 'rsaEncryption':
              {
                _type = 'pkcs1';
                keyObject = _createPublicKey({
                  type: _type,
                  key: parsed.publicKey.data,
                  format: 'der'
                });
                break;
              }

            default:
              unsupported(parsed.algorithm.algorithm);
          }

          return keyObject;
        }

      case 'pkcs1':
        {
          var _RSAPublicKey = asn1.get('RSAPublicKey');

          var _parsed2 = _RSAPublicKey.decode(key, format, {
            label: label
          }); // special case when private pkcs1 PEM / DER is used with createPublicKey


          if (_parsed2.n === BigInt(0)) {
            return _createPublicKey(_createPrivateKey2({
              key: key,
              format: format,
              type: type,
              passphrase: passphrase
            }));
          }

          var _keyObject = new KeyObject();

          _keyObject._asn1 = _parsed2;
          _keyObject._asymmetricKeyType = 'rsa';
          _keyObject._type = 'public';
          _keyObject._pem = _RSAPublicKey.encode(_parsed2, 'pem', {
            label: 'RSA PUBLIC KEY'
          });
          return _keyObject;
        }

      case 'pkcs8':
      case 'sec1':
        return _createPublicKey(_createPrivateKey2({
          format: format,
          key: key,
          type: type,
          passphrase: passphrase
        }));

      default:
        throw new TypeError("The value ".concat(type, " is invalid for option \"type\""));
    }
  };

  _createPrivateKey2 = function createPrivateKey(input, hints) {
    if (typeof input === 'string' || Buffer.isBuffer(input)) {
      input = {
        key: input,
        format: 'pem'
      };
    }

    if (!isObject(input)) {
      throw new TypeError('input must be a string, Buffer or an object');
    }

    var _input3 = input,
        format = _input3.format,
        passphrase = _input3.passphrase;
    var _input4 = input,
        key = _input4.key,
        type = _input4.type;

    if (typeof key !== 'string' && !Buffer.isBuffer(key)) {
      throw new TypeError('key must be a string or Buffer');
    }

    if (passphrase !== undefined) {
      throw new errors.JOSENotSupported('encrypted private keys are not supported in your Node.js runtime version');
    }

    if (format !== 'pem' && format !== 'der') {
      throw new TypeError('format must be one of "pem" or "der"');
    }

    var label;

    if (format === 'pem') {
      key = key.toString();

      switch (key.split(/\r?\n/g)[0].toString()) {
        case '-----BEGIN PRIVATE KEY-----':
          type = 'pkcs8';
          label = 'PRIVATE KEY';
          break;

        case '-----BEGIN EC PRIVATE KEY-----':
          type = 'sec1';
          label = 'EC PRIVATE KEY';
          break;

        case '-----BEGIN RSA PRIVATE KEY-----':
          type = 'pkcs1';
          label = 'RSA PRIVATE KEY';
          break;

        default:
          throw new TypeError('unknown/unsupported PEM type');
      }
    }

    switch (type) {
      case 'pkcs8':
        {
          var PrivateKeyInfo = asn1.get('PrivateKeyInfo');
          var parsed = PrivateKeyInfo.decode(key, format, {
            label: label
          });

          var _type2, keyObject;

          switch (parsed.algorithm.algorithm) {
            case 'ecPublicKey':
              {
                _type2 = 'sec1';
                keyObject = _createPrivateKey2({
                  type: _type2,
                  key: parsed.privateKey,
                  format: 'der'
                }, _defineProperty({}, namedCurve, parsed.algorithm.parameters.value));
                break;
              }

            case 'rsaEncryption':
              {
                _type2 = 'pkcs1';
                keyObject = _createPrivateKey2({
                  type: _type2,
                  key: parsed.privateKey,
                  format: 'der'
                });
                break;
              }

            default:
              unsupported(parsed.algorithm.algorithm);
          }

          keyObject._pkcs8 = key;
          return keyObject;
        }

      case 'pkcs1':
        {
          var RSAPrivateKey = asn1.get('RSAPrivateKey');

          var _parsed3 = RSAPrivateKey.decode(key, format, {
            label: label
          });

          var _keyObject2 = new KeyObject();

          _keyObject2._asn1 = _parsed3;
          _keyObject2._asymmetricKeyType = 'rsa';
          _keyObject2._type = 'private';
          _keyObject2._pem = RSAPrivateKey.encode(_parsed3, 'pem', {
            label: 'RSA PRIVATE KEY'
          });
          return _keyObject2;
        }

      case 'sec1':
        {
          var ECPrivateKey = asn1.get('ECPrivateKey');

          var _parsed4 = ECPrivateKey.decode(key, format, {
            label: label
          });

          if (!('parameters' in _parsed4) && !hints[namedCurve]) {
            throw new Error('invalid sec1');
          } else if (!('parameters' in _parsed4)) {
            _parsed4 = _objectSpread({}, _parsed4, {
              parameters: {
                type: 'namedCurve',
                value: hints[namedCurve]
              }
            });
          }

          var _keyObject3 = new KeyObject();

          _keyObject3._asn1 = _parsed4;
          _keyObject3._asymmetricKeyType = 'ec';
          _keyObject3._type = 'private';
          _keyObject3._pem = ECPrivateKey.encode(_parsed4, 'pem', {
            label: 'EC PRIVATE KEY'
          });
          return _keyObject3;
        }

      default:
        throw new TypeError("The value ".concat(type, " is invalid for option \"type\""));
    }
  };
}

module.exports = {
  createPublicKey: _createPublicKey,
  createPrivateKey: _createPrivateKey2,
  createSecretKey: createSecretKey,
  KeyObject: KeyObject,
  asInput: asInput
};